import { render, staticRenderFns } from "./ConfirmDialogue.vue?vue&type=template&id=c674d84c&scoped=true&"
import script from "./ConfirmDialogue.vue?vue&type=script&lang=js&"
export * from "./ConfirmDialogue.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDialogue.vue?vue&type=style&index=0&id=c674d84c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c674d84c",
  null
  
)

export default component.exports